import React, { useState } from 'react';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { CancelRounded, Close } from '@mui/icons-material';
import myFunctions from '../myFunctions';

const PopUpPhoneCheckCode = (props) => {


    const [open, setOpen] = useState(true);
    const [inputTxt, setInputTxt] = useState("");
    const [err, setErr] = useState(props.showError ? true : false);
    const [erMsg, setErMsg] = useState(props.errorMsg);

    const saveMe = () => {
        if (inputTxt !== "") {
            props.okClick(inputTxt);
        }
        else {
            setErr(true);
        }
    };


    const handleClose = () => {
        if (typeof props.cancelClick === 'function') props.cancelClick();
    };

    myFunctions.useEscapeKey(handleClose);

    const handleKeyUp = (event) => {
        if (event.key === 'Enter') {
            saveMe();
        }
    };


    const [timer, setTimer] = useState(60);
    const [canResend, setCanResend] = useState(false);

    React.useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);
            return () => clearInterval(interval);
        } else {
            setCanResend(true);
        }
    }, [timer]);

    const handleResendCode = () => {
        if (canResend) {
            props.recreateCode();
            setTimer(60);
            setCanResend(false);
        }
    };

    return (
        <Dialog open={open} className={`textSizeDiag popDiagBlock ${props.cssStyl || ""}`}>
            <div className="headAndBtnWrap spaceButtomBig">
                <button type="button" className="btnReset backS" aria-label="סגור" onClick={handleClose}>
                    <Close className="pointing" aria-hidden="true" />
                </button>
                <div className="bold veryBig spacePadBig">
                    {props.topTitle ? props.topTitle : "התחברות"}
                </div>
                <div className="lineDotted"></div>
            </div>
            {(props.topSlides != null) ?
                props.topSlides : ""
            }
            {props.topImg && <div className="imgblok" style={{ backgroundImage: `url(${props.topImg})` }}></div>}
            <div className="firstMastSec">
                <div className="insideFrame">

                    <DialogTitle className="regularFont noPadding normalLine">
                        {props.Title.map((txtItm, index) => (
                            <span className="huge arrowing" key={index}>{txtItm}</span>
                        ))}
                    </DialogTitle>

                    <DialogContent className="noPadding normalLine spaceMargTopBig">
                        <DialogContentText className="spaceButtomBig normalLine">
                            {props.ContentText.map((txtItm, index) => (
                                <span className="big arrowing" key={index}>{txtItm}<br /></span>
                            ))}
                        </DialogContentText>
                        <label className="sr-only" htmlFor="inputPhonetx">{props.placeholdTxtF || "מספר נייד"}</label>
                        <input
                            id="inputPhonetx"
                            className="spaceTopBig inputPhonetx"
                            placeholder={`${props.placeholdTxtF || "מספר נייד"} `}
                            value={inputTxt}
                            onChange={(e) => {
                                setInputTxt(e.target.value); setErr(false)
                            }}
                            onKeyUp={handleKeyUp}
                            label={props.inLabel}
                            variant="filled"
                            type="number"
                            inputMode="numeric"
                            autoFocus
                        />



                    </DialogContent>
                    <DialogActions>
                        <div className="fullRow">
                            <div className="fullRow">
                                <button type="button" className="btnReset connectBtn conClear bold big pointing" onClick={saveMe}>אימות</button>
                            </div>
                        </div>
                    </DialogActions>

                    <DialogActions>
                        <div className="fullRow">
                            {err ? <div role="alert" style={{ color: 'red', fontWeight: 'bold' }}>{props.errorMsg}</div> : ""}
                            {canResend ? (
                                <button type="button" onClick={handleResendCode} className={"btnReset spacePadBig centerText pointing centerMargin"} style={{ display: 'block' }}>שלח לי שוב</button>
                            ) : (
                                <p className={"spacePadBig centerText"} style={{ color: '#666' }}>לנסיון שליחה חוזרת יש להמתין {timer} שניות</p>
                            )}
                        </div>
                    </DialogActions>
                </div>


            </div>
        </Dialog >

    );
}

export default PopUpPhoneCheckCode;